import React, { FC } from "react"

interface Props {
  className?: string
}

const ChevronLeftLargeIcon: FC<Props> = ({ className }) => {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      className={className}
    >
      <path
        d="M20 24L12 16L20 8"
        stroke="#2F3B5A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default ChevronLeftLargeIcon
